// extracted by mini-css-extract-plugin
export default {"content":"UnavailabilityActionAskIfProductiveStarterWorker_content__hwP0V","askIfAssignedWork":"UnavailabilityActionAskIfProductiveStarterWorker_askIfAssignedWork__8ocBx"};